export default __webpack_public_path__ + "static/media/img3.5c204f01.jpg";